import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MAP_READABLE_NAME_TO_PERIOD } from 'src/js/modules/common/constants/terms';
import segment from '../../modules/analytics/segment';
import EcommercePaywallContainer from '../../modules/paywall/containers/ecommerce-paywall-container';
import useSupportedSearchParams from '../hooks/use-supported-search-params';
import routesMap from '../helpers/routes-map';
import { premiumFeatures } from '../../modules/common/constants/premium-features';

const {
  constants: { triggerIds },
} = segment;

function EcommercePaywallRoute() {
  const searchParams = useSupportedSearchParams();
  const navigate = useNavigate();

  if (!searchParams) return null;

  const {
    initiator,
    products = [],
    term,
    premiumFeature,
    triggerId,
    actionId,
    back,
    periodToggle,
    paymentBackUrl,
  } = searchParams;
  const hasProducts = Boolean(products.length);

  const propsFromSearchParams = {
    ...(initiator && { initiator }),
    ...(premiumFeature && { premiumFeature }),
    ...(hasProducts && { extraProducts: products }),
    ...(term && { term }),
    ...(triggerId && { triggerId }),
    ...(actionId && { actionId }),
    ...(back && { backUrl: back }),
    ...(paymentBackUrl && { paymentBackUrl }),
    periodToggle: periodToggle !== false,
  };

  const showHostingSelector = ({ selectedPlan, selectedTerm, promoCampaignId }) => {
    const productsParam = [...products, selectedPlan].join();

    const query = {
      products: productsParam,
      term: MAP_READABLE_NAME_TO_PERIOD[selectedTerm],
      triggerId: triggerIds.ECOMMERCE_PAYWALL,
      ...(premiumFeature ? { premiumFeature } : { premiumFeature: premiumFeatures.ECOMMERCE }),
      ...(paymentBackUrl && { paymentBackUrl }),
      ...(promoCampaignId && { promoCampaignId }),
      ...(actionId && { actionId }),
    };

    navigate(
      routesMap.paywall.url({
        query,
      })
    );
  };

  return (
    <EcommercePaywallContainer
      showHostingSelector={showHostingSelector}
      {...propsFromSearchParams}
    />
  );
}

export default EcommercePaywallRoute;
